import { AdditionalPlayerInfo } from '@base/features/game/model/types';
import { t } from '@base/utils/helpers';
import React, { FC, useEffect } from 'react';
import { Avatar } from '../avatar/components/avatar';
import MainButton from '@ui-kit/components/mainButton';
import { JoinTableMode } from '../lobby/component/tableListLayout/tableList/tableList';
import { container } from 'tsyringe';
import btn_ladder from '../../assets/images/btn_ladder.svg';
import { MessagesService } from '@base/features/chat/messagesService';
import Rating from '../user/components/rating';
import Flag from '@ui-kit/components/flag';
import { IPlayer, IPlayersOnlineRepository } from '../player/model/interfaces';
import LobbyService from '../lobby/model/lobbyService';

export const PlayerAdditionalInfo = (props: { player: IPlayer }) => {
  const lobbyService: LobbyService = container.resolve('lobbyService');
  const messagesService: MessagesService = container.resolve('messagesService');
  const playersOnlineRepository: IPlayersOnlineRepository = container.resolve('playersOnlineRepository');
  const info: AdditionalPlayerInfo = props.player.getAdditionalInfo();

  const table = props.player.getTable();
  const canWatchTable = table && table.canBeWatched() && !playersOnlineRepository.me?.getTable();
  const canPlayTable = table && table.canBePlayed() && !playersOnlineRepository.me?.getTable();

  useEffect(() => {
    //ToDO Временное решение - нужно выносить всю логику и отображать компонент, только когда в updatePlayerStat приходит ответ на наш запрос
    playersOnlineRepository.sendFingerPid(props.player.getPid());
  }, [playersOnlineRepository, props.player]);

  const btnStartChatWithPlayerJsx = (
    <MainButton className="main-btn player-additional-info__footer-btn" onClick={joinChat}>
      {t('chat')}
    </MainButton>
  );

  function joinChat() {
    messagesService.joinPrivatChat(props.player);
  }

  function joinTable(mode: JoinTableMode) {
    if (!table) return;
    // Если я уже сижу за столом - ничего не делать
    if (playersOnlineRepository.me?.getTable()) return;
    const tid = table.tid;
    mode === JoinTableMode.PLAY ? lobbyService.playTable(tid) : lobbyService.watchTable(tid);
  }

  const btnWatchJsx = canWatchTable && (
    <MainButton
      className="main-btn player-additional-info__footer-btn"
      onClick={() => joinTable(JoinTableMode.WATCH)}
    >
      {t('watch')}
    </MainButton>
  );

  const titleBtnWatch = canWatchTable && (
    <>
      <span>{t('status')}</span>
      <span>{`${t('_playing_on_table_')} #${table?.getNumber()}`}</span>
    </>
  );

  const btnPlayJsx = canPlayTable && (
    <MainButton
      className="main-btn player-additional-info__footer-btn"
      onClick={() => joinTable(JoinTableMode.PLAY)}
    >
      <div className="table-list__play-ladder-wrap">
        {t('play')}
        <div>
          {table && table.ladder ? (
            <img className="table-list__play-ladder-img" src={btn_ladder} alt="icon ios" />
          ) : null}
        </div>
      </div>
    </MainButton>
  );

  const titleBtnPlay = canPlayTable && (
    <>
      <span>{t('status')}</span>
      <span>{`${t('waiting_at_table')} #${table?.getNumber()}`}</span>
    </>
  );

  return (
    <div className="player-additional-info">
      <header className="player-additional-info__header">
        <div className="player-additional-info__player-card">
          <Avatar classes="player-additional-info__avatar" player={props.player} />

          <div className="player-additional-info__user">
            <span>{props.player.getName()}</span>
            <div className="player-additional-info__user-rating">
              <Flag countryCode={props.player.countryCode} style={{ marginRight: '.8rem' }} />
              <Rating>{props.player.getRating()}</Rating>
            </div>
          </div>
        </div>
        <div className="player-additional-info__status">
          {titleBtnWatch}
          {titleBtnPlay}
        </div>
        {btnWatchJsx}
        {btnPlayJsx}
      </header>

      <div className="player-additional-info__params">
        {/*top3*/}
        <span>{t('tourneys_top_3')}</span>
        <span>{`${info.tourneysTop1 + info.tourneysTop2 + info.tourneysTop3} ${t('of')} ${
          info.tourneysTotal
        }`}</span>

        {/*mini*/}
        <span>{t('mini-tourneys')}</span>
        <span>{`${info.miniTourneysWin} ${t('of')} ${info.miniTourneys}`}</span>

        {/*ladder ranked*/}
        <span>{t('ladder_ranking')}</span>
        <span>{info.ladderRanking < 0 ? t('none') : info.ladderRanking}</span>

        {/*total game/*/}
        <span>{t('total_games')}</span>
        <span>{info.totalGames}</span>

        <span>{t('won')}</span>
        <span>{info.won}</span>

        <span>{t('lost')}</span>
        <span>{info.lost}</span>

        <span>{t('max_rating')}</span>
        <span>{info.maxRating}</span>
      </div>

      <footer className="player-additional-info__footer">{btnStartChatWithPlayerJsx}</footer>
    </div>
  );
};
